import { defineMessages } from 'react-intl';

export default defineMessages({
  senderName: {
    id: 'pricing.giftCard.senderName',
    defaultMessage: 'Sender name *',
  },
  senderEmailAddress: {
    id: 'pricing.giftCard.senderEmail',
    defaultMessage: 'Sender email address *',
  },
  recipientName: {
    id: 'pricing.giftCard.recipientName',
    defaultMessage: 'Recipient name *',
  },
  recipientEmailAddress: {
    id: 'pricing.giftCard.recipientEmail',
    defaultMessage: 'Recipient email address *',
  },
  pleaseAddSenderName: {
    id: 'pricing.giftCard.senderNameError',
    defaultMessage: 'Please add a sender name',
  },
  pleaseEnterValidEmailAddress: {
    id: 'pricing.giftCard.emailError',
    defaultMessage: 'Please enter a valid email address',
  },
  pleaseAddRecipientName: {
    id: 'pricing.giftCard.recipientNameError',
    defaultMessage: 'Please add a recipient name',
  },
  giftMessage: {
    id: 'pricing.giftCard.message',
    defaultMessage: 'Message',
  },
  senderNamePlaceHolder: {
    id: 'common.giftcardform.senderNamePlaceHolder',
    defaultMessage: 'Alex Doe',
  },
  senderEmailAddressPlaceHolder: {
    id: 'common.giftcardform.senderEmailAddressPlaceHolder',
    defaultMessage: 'alex.doe@email.com',
  },
  recipientNamePlaceHolder: {
    id: 'common.giftcardform.recipientNamePlaceHolder',
    defaultMessage: 'Alex Doe',
  },
  recipientEmailAddressPlaceHolder: {
    id: 'common.giftcardform.recipientEmailAddressPlaceHolder',
    defaultMessage: 'alex.doe@email.com',
  },
});
